<template>
  <div class="take-over--editor-info" v-if="!recentUpdate">
    <aha-avatar
      class="take-over--avatar"
      :name="currentUser.firstName"
      :image="currentUser.avatar"
      :id="currentUser.id"
    />

    <p class="take-over--editor-text">
      {{ $i18nPresenter.t('You can view and present this presentation.') }}
      <a
        class="font-bold text-link float-right"
        @click="$emit('reload')"
        v-tooltip="$i18nPresenter.t('Refresh to view the latest version')"
      >
        {{ $i18nPresenter.t('Refresh') }}</a>
    </p>
  </div>
  <div class="take-over--editor-info" v-else>
    <aha-icon
      name="info-circle-o"
      class="text-base-70 mt-1.5"
      viewBox="0 0 22 22"
      width="22"
      height="22"
      maintainColor="false"
    />
    <p class="take-over--editor-text">
      {{ $i18nPresenter.t('Slide updated') }} {{ recentUpdate }}
      <a
        class="font-bold text-link float-right"
        :class="{ 'opacity-50 pointer-events-none': isUpdating }"
        @click="!isUpdating && syncPresentationWithRoot()"
        v-tooltip="$i18nPresenter.t('Get the latest slides and reset results. Your current results will be saved in Report')"
      >
        {{ $i18nPresenter.t('Update') }}
      </a>
    </p>
  </div>
</template>

<script>
import moment from 'moment'
import * as Sentry from '@sentry/vue'
import PresentationApi from '@/api/presentation'

export default {
  name: 'PresentationViewOnlyInfoBar',
  props: {
    presentationId: {
      type: [String, Number],
      required: true,
    },
    presentationLastUpdated: {
      type: String,
      required: true,
    },
    currentUser: {
      type: Object,
    },
  },
  data() {
    return {
      recentUpdate: '',
      isUpdating: false,
    }
  },
  mounted() {
    this.checkForUpdate()
    // Optionally, poll every 60s:
    this._interval = setInterval(this.checkForUpdate, 60000)
  },
  beforeDestroy() {
    if (this._interval) clearInterval(this._interval)
  },
  methods: {
    async checkForUpdate() {
      try {
        const res = await PresentationApi.getRootPresentationUpdateTime(this.presentationId)
        if (res && res.lastUpdatedAt && new Date(res.lastUpdatedAt) > new Date(this.presentationLastUpdated)) {
          this.recentUpdate = moment(res.lastUpdatedAt).fromNow()
        } else {
          this.recentUpdate = ''
        }
      } catch (e) {
        Sentry.captureException(e)
        // On error, hide the button
        this.recentUpdate = ''
      }
    },

    async syncPresentationWithRoot() {
      this.isUpdating = true
      await PresentationApi.syncWithRootPresentation(this.presentationId)
      this.$emit('reload')
    },
  },
}
</script>
